import { a as o, b as e, c as a, d as s, e as t, f as p, g as r, l as R, m as i, h as l, o as u, i as n } from "./index-BTIwQSAj.js";
const m = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  authRepo: o,
  basketRepo: e,
  bootstrapRepo: a,
  businessRepo: s,
  customerRepo: t,
  discountRepo: p,
  giftCardRepo: r,
  loyaltyRepo: R,
  menuRepo: i,
  migrationRepo: l,
  orderRepo: u,
  outletRepo: n
}, Symbol.toStringTag, { value: "Module" }));
export {
  m as r
};
